export default "__VITE_ASSET__iFyCHf$z__"